import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import {
  InvoiceKsefStatus,
  InvoiceNumber,
  InvoiceStatus,
  InvoiceType,
} from '@web/shared/module/shop';
import { AdminInvoiceContextOperationsResponse } from './admin-invoice-context-operations.response';

@jsonObject
export class AdminInvoiceCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: InvoiceNumber;

  @jsonMember(String)
  public readonly status!: InvoiceStatus;

  @jsonMember(String)
  public readonly ksefStatus!: InvoiceKsefStatus;

  @jsonMember(String)
  public readonly type!: InvoiceType;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Boolean)
  public readonly hasError?: Nillable<boolean>;

  @jsonMember(String)
  public readonly errorMessage?: Nillable<string>;

  @jsonMember(String)
  public readonly taskReferenceNumber?: Nillable<string>;

  @jsonMember(String)
  public readonly ksefNumber?: Nillable<string>;

  @jsonMember(AdminInvoiceContextOperationsResponse)
  public readonly contextOperations!: AdminInvoiceContextOperationsResponse;
}
